import { ru, type Dict } from "./ru";

/**
 * Super-Admin одноязычный — без LangProvider'а / context'а / switcher'а.
 * Прямой импорт `ru`. Если в будущем добавится EN/KZ — обернём в Provider.
 */
export function useT(): Dict {
  return ru;
}

export type { Dict };
